import React from 'react';
import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { usePathname } from 'expo-router';
import SheetModal from '@/components/General/SheetModal';
import PersonProfileNew from '@/app/(tabs)/(home,search,notifications,settings)/people/[personID]';

/**
 * Opens a person's full profile inside a SheetModal so the user never leaves
 * the current screen/modal. Route-pushing a card screen on top of a modal
 * presentation doesn't stack reliably (web replaces, native dismisses the
 * underlying modal), so the profile component renders inside a
 * component-level modal instead. Person-only for now; other record types can
 * be added later if needed.
 *
 * @param {string|null} personID - The person to show. When non-null, the modal opens.
 * @param {Function} onClose - Called when the modal is dismissed.
 * @param {string} [title="Profile"] - Sheet header title.
 * @param {string} [subtitle] - Sheet header subtitle.
 * @param {string} [confirmText] - Header confirm action label. Renders only when onConfirm is set
 *   (e.g. "Send to Assistant"). Confirm does not auto-close the sheet — close via onClose in the handler.
 * @param {Function} [onConfirm] - Header confirm action callback.
 * @param {string} [testID] - testID applied to the modal content wrapper.
 */
const PersonProfileModal = ({ personID, onClose, title = 'Profile', subtitle, confirmText, onConfirm, testID }) => {
    const fromScreen = usePathname();
    return (
        <SheetModal
            isOpen={!!personID}
            onClose={onClose}
            onCancel={onClose}
            title={title}
            subtitle={subtitle}
            cancelText="Close"
            confirmText={confirmText}
            onConfirm={onConfirm}
            width={600}
        >
            <View testID={testID} style={styles.content}>
                {personID && <PersonProfileNew personID={personID} fromScreen={fromScreen} forceSingleColumn />}
            </View>
        </SheetModal>
    );
};

const styles = StyleSheet.create(() => ({
    content: {
        flex: 1,
    },
}));

export default PersonProfileModal;
